module.exports = __webpack_public_path__ + "img/conigt.57dbb8f4.png";